exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.custom[data-v-e9c936ca] {\n  width: 120px;\n}\ndiv.input[data-v-e9c936ca],\ndiv.input > div[data-v-e9c936ca] {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  height: 39px;\n}\n.actions > li[data-v-e9c936ca] {\n  margin-left: 1rem;\n}\n.actions > li[data-v-e9c936ca]:first-child {\n    margin-left: 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-e9c936ca","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/reservations/TransportForm.vue
// module id = 2188
// module chunks = 0